module.exports = __webpack_public_path__ + "img/H-45-ER-1000-N.ca678d89.png";